module.exports = __webpack_public_path__ + "static/media/DSC_7085.fea27cfb.jpg";